import { WordObject } from '../../interfaces/word-object/WordObject';
import { ITEM_TYPES } from '../../item/item-types';
import { MESSAGE_TYPES } from '../../item/message-types';
import { AbstractChatMessage } from './abstract-chat-message';
import { DictionaryContent } from './dictionary-content-interface';
import { InteractiveChatJourneyType } from './interactive-chat-journey-type';
import { MessageData } from './message-data';

export class InteractiveChatJourneyMessage extends AbstractChatMessage {
    content: InteractiveChatJourneyType;
    constructor(){
        super()
        this.setType(MESSAGE_TYPES.InteractiveChatJourney)
    }
}